import Miner from "./index";

export default Miner